import { render } from "./AreaDivision.vue?vue&type=template&id=e0e5811a"
import script from "./AreaDivision.vue?vue&type=script&lang=js"
export * from "./AreaDivision.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__